import { useCallback } from 'react'
import { useSetRecoilState, useRecoilValue } from "recoil"
import { CommonTemplateAtom } from "../atom/GlobalAtom"

// 背景のstateを管理
type CommonHeader = State & {
  disable: () => void;
  enable: () => void;
};

type State = {
  enabled: boolean;
};

export default function useCommonTemplate(): CommonHeader {

  const enabled = useRecoilValue(CommonTemplateAtom);
  const setEnabled = useSetRecoilState(CommonTemplateAtom);

  const enable = () => setEnabled(true);
  const disable = () => setEnabled(false);

  return {
    enabled,
    disable,
    enable,
  };
}
